import { render, staticRenderFns } from "./RipaPiiReview.vue?vue&type=template&id=08b2ead7"
import script from "./RipaPiiReview.vue?vue&type=script&lang=js"
export * from "./RipaPiiReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports